<div class="crm-shell flex-column background-glass">
    <div class="crm-header">
        <h1 class="crm-title" translate>CRM.TITLE</h1>
    </div>

    <nav class="crm-tabs">
        <!-- Top-level CRM areas. "Leads" carries its own sub-tabs (Liste / Pipeline); further areas
             (e.g. Mitglieder) sit next to these later. -->
        <a class="crm-tab" routerLink="/crm/dashboard" routerLinkActive="active">
            <mat-icon>insights</mat-icon><span translate>CRM.TAB.DASHBOARD</span>
        </a>
        <a class="crm-tab" routerLink="/crm/leads" routerLinkActive="active">
            <mat-icon>trending_up</mat-icon><span translate>CRM.TAB.LEADS</span>
        </a>
        <a class="crm-tab" routerLink="/crm/mitglieder" routerLinkActive="active">
            <mat-icon>groups</mat-icon><span translate>CRM.TAB.MEMBERS</span>
        </a>
        <a class="crm-tab" routerLink="/crm/wiedervorlagen" routerLinkActive="active">
            <mat-icon>event_repeat</mat-icon><span translate>CRM.TAB.WIEDERVORLAGEN</span>
        </a>
        <a class="crm-tab" routerLink="/crm/stufen" routerLinkActive="active">
            <mat-icon>tune</mat-icon><span translate>CRM.TAB.STAGES</span>
        </a>
    </nav>

    <div class="crm-body">
        <router-outlet></router-outlet>
    </div>
</div>
